export default __webpack_public_path__ + "static/media/reporting-sprite-1e8629aaaaf51f1303d077c1f3d20abc.png";